import React, { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useRouter } from 'next/router';
import useAuthenticationCheck from '../api/hooks/queries/Auth/useAuthenticationCheck';
import AuthCheckRequest from '../api/requests/Auth/AuthCheckRequest';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';
import { parseUser } from '../utils/parseUser';

type Props = {
	children: JSX.Element;
};

export default function OpenRoute({ children }: Props) {
	const [component, setComponent] = useState<JSX.Element | null>(null);
	const { push } = useRouter();
	const queryClient = useQueryClient();
	const { data: user } = useAuthenticationCheck(true);

	// authenticated authenticated, back to login
	useEffect(() => {
		if (!user) {
			setComponent(children);
		}

		AuthCheckRequest()
			.then(response => {
				queryClient.setQueryData('user', parseUser(response.data));
				push('/dashboard');
			})
			.catch(() => {
				setComponent(children);
			});
	}, [user, children, queryClient, push]);

	if (component === null) return <LoadingScreen />;

	return component;
}
